(function () {
  const modal = document.getElementById('modal__wrapper');
  const modalBtn = document.getElementById('modal__btn');
  const closeBtn = document.getElementsByClassName('button-close')[0];

  if (!modal) return;

  // Trap focus inside the modal
  modal.addEventListener('keydown', function (event) {
    const focusableElements = modal.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey) {
        // If shift key is pressed, focus the last focusable element
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        // If shift key is not pressed, focus the first focusable element
        if (document.activeElement === lastFocusableElement) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  });

  modalBtn.onclick = function () {
    modal.style.display = 'block';
    modal.setAttribute('aria-hidden', 'false');
    const focusableElements = modal.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );
    const firstFocusableElement = focusableElements[0];
    firstFocusableElement.focus();
  };

  closeBtn.onclick = function () {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  };

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
    }
  };
})();
